import React, { useRef, useEffect, useState } from 'react'
import PreLoaderProgressBar from 'components/PreLoader/components/PreLoaderProgressBar'
import { applyBlurEffectToCanvas, opencvGaussianBlur, opencvMedianBlur, opencvMotionBlur, opencvDefocusBlur } from './utils'

const AugmentationEditorBlur = ({ selectedOption, previewImage, color }) => {
  const srcCanvasRef = useRef(null)
  const dstCanvasRef = useRef(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!previewImage) return
    setLoading(true)
    const getBlurValues = selectedOption.newValues || selectedOption.defaultValues
    const srcCanvas = srcCanvasRef.current
    const dstCanvas = dstCanvasRef.current
    const img = new window.Image()
    img.crossOrigin = 'anonymous'
    img.src = previewImage
    img.onload = () => {
      setTimeout(() => {
        applyBlurEffectToCanvas(srcCanvas, dstCanvas, img, getBlurValues, {
          opencvGaussianBlur,
          opencvMedianBlur,
          opencvMotionBlur,
          opencvDefocusBlur
        })
        setLoading(false)
      }, 100)
    }
  }, [selectedOption, previewImage])

  return (
    <div>
      {loading && (
        <div className='augmentation-editor-preview__loading'>
          <PreLoaderProgressBar
            isVertical
            isLoading
            color={color}
            label='Loading image'
            width='0%'
          />
        </div>
      )}
      <canvas ref={srcCanvasRef} className='augmentation-editor-preview__canvas-spacer' />
      <canvas ref={dstCanvasRef} className='augmentation-editor-preview__canvas' />
    </div>
  )
}

export default AugmentationEditorBlur